import React from 'react'
import { reduxForm } from 'redux-form'
import CustomButton from './CustomButton'
import FooterText from './FooterText';
import { connect } from 'react-redux'
import { compose } from 'redux'

let CustomForm = props => {
  const { handleSubmit, children } = props;
  const childrenWithProps = React.Children.map(children, child => {
    if (child) {
      return React.cloneElement(child, { ...props })
    }
    else {
      return null
    }
  });
  return (
    <div className='form-container'>
      <form onSubmit={handleSubmit}>
        <div>
          {childrenWithProps}
        </div>
        <br />
        <CustomButton {...props} disabled={props.pristine || props.isLoading} />
        {
          props.err ?
            <div className='error'>
              <br />
              <div className='inner'>{props.err}</div>
            </div>
            : null
        }
        <br />
      </form>
      {
        props.service != 'metro' && <FooterText />
      }
    </div>
  );
}

//It is important to understand currying JS functions to deeply understand
//the code implemented here. The basic idea is to pass the values from the props through
//connect function which passes the config object to ReduxForm decorator in order to build 
//the form dynamically using different form fields and configuration options
CustomForm = compose(
  connect((state, props) => {
    return {
      form: props.form_name,
      destroyOnUnmount: props.destroy,
    }
  }),
  reduxForm(),
)(CustomForm);

export default CustomForm


// WEBPACK FOOTER //
// ./src/components/CustomForm.js